module.exports = __webpack_public_path__ + "static/img/萌宫天街2.41906ae6.png";